import { render } from "./MainSlideBaiViet.vue?vue&type=template&id=70c5dc3c&scoped=true"
import script from "./MainSlideBaiViet.vue?vue&type=script&lang=js"
export * from "./MainSlideBaiViet.vue?vue&type=script&lang=js"

import "./MainSlideBaiViet.vue?vue&type=style&index=0&id=70c5dc3c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c5dc3c"]])

export default __exports__